<script lang="ts">
  import { config } from '#app/config'
  import { screen } from '#app/lib/components/stores/screen'
  import { locationStore } from '#app/lib/location_store'
  import { loadInternalLink } from '#app/lib/utils'
  import TopBarButtons from '#components/top_bar_buttons.svelte'
  import TopBarLanguagePicker from '#components/top_bar_language_picker.svelte'
  import GlobalSearchBar from '#search/components/global_search_bar.svelte'
  import { I18n } from '#user/lib/i18n'
  import { mainUser } from '#user/lib/main_user'

  let displayConnectionButtons = false

  $: smallScreen = $screen.isSmallerThan('$small-screen')

  const { instanceName } = config

  $: {
    const { section } = $locationStore
    const onConnectionPage = (section === 'signup') || (section === 'login')
    displayConnectionButtons = !(smallScreen && onConnectionPage)
  }
</script>

<nav>
  <!-- svelte-ignore a11y-missing-content -->
  <a id="goToMain" href="#main" title={I18n('skip to main content')} />

  {#if mainUser}
  <GlobalSearchBar />
  {:else}
    <h1 class="respect-case">
    <a id="home" href="/" on:click={loadInternalLink}>{instanceName}</a>
  </h1>
    <div class="search-placeholder"></div>
  {/if}

  <TopBarLanguagePicker />

  {#if mainUser}
    <TopBarButtons />
  {:else if displayConnectionButtons}
    <a
      class="login-request"
      href="/login"
      on:click={loadInternalLink}
    >
      {I18n('login')}
    </a>
  {/if}
</nav>

<style lang="scss">
  @import "#general/scss/utils";

  nav{
    // Screens that have enough vertical space to display the full top bar menu,
    // without needing to scroll
    @media screen and (height >= $top-bar-fixed-threshold){
      // Use position:fixed to make the top-bar stick to the screen top
      @include position(fixed, 0, 0, null, 0);
    }
    @include display-flex(row, center, flex-start);
    height: 3em;
    background-color: $topbar-bg-color;
  }
  h1{
    font-size: 1rem;
    font-weight: bold;
    line-height: 2rem;
    // /!\ Defines the top-bar height
    padding: 0.1rem 0.5rem;
  }
  a#home{
    color: white;
    font-weight: bold;
  }
  .login-request{
    font-weight: bold;
    color: white;
    white-space: nowrap;
    @include display-flex(row, center, center);
    align-self: stretch;
    padding: 0 1em;
    @include bg-hover($success-color, 5%);
  }
  .search-placeholder{
    align-self: center;
    flex: 1 0 0;
    // 7 = max number of search section on a row
    max-width: 7 * $search-section-width;
    margin: 0 auto;
    margin-block-end: 0;
    position: relative;
    background-color: transparent;
    @include radius;
  }


  /* Small screens */
  @media screen and (width < $small-screen){
    nav{
      padding: 0.5em 0.2em 0.2em 0.2em;
    }
    .search-placeholder{
      height: 2rem;
      flex: 1 1 auto;
      flex-direction: row;
      flex-wrap: nowrap;
      margin-inline-start: auto;
      margin-block-start: -0.3em;
    }
  }
</style>
